import { render, staticRenderFns } from "./UpdateWatch.vue?vue&type=template&id=2a4cec0e&scoped=true"
import script from "./UpdateWatch.vue?vue&type=script&lang=js"
export * from "./UpdateWatch.vue?vue&type=script&lang=js"
import style0 from "./UpdateWatch.vue?vue&type=style&index=0&id=2a4cec0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4cec0e",
  null
  
)

export default component.exports